import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Drawer, Input, Space, Button, message } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import React, { useContext } from 'react';
import { ApplicationUIContext, Form } from '@yuhuinc/ui-library';
import { CurrentApplicationContext } from '../../ApplicationOverview';
import { apiPost } from 'helpers/ApiHelper';
import { onError } from '../../common/ErrorHandling';
const { TextArea } = Input;

const RequestChangesDrawer = ({ drawerState }) => (
  <Drawer
    title={getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.actions.requestChanges'
    )}
    visible={drawerState.isVisible}
    closable
    destroyOnClose
    onClose={drawerState.close}
  >
    <RequestChangesForm drawerState={drawerState} />
  </Drawer>
);

const requiredField = {
  required: true,
  message: getTranslatedString('requiredField'),
};

const RequestChangesForm = ({ drawerState }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const currentApplication = useContext(CurrentApplicationContext);
  const queryClient = useQueryClient();

  const requestChangesMutation = useMutation({
    mutationFn: (data) => {
      return apiPost(
        `/landlords/application_management/applications/${currentApplication.id}/request_changes`,
        data
      );
    },
    onSuccess() {
      // Update message once we get feedback from design team
      message.success('Changes requested');
      drawerState.close();
    },
    onError,
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ['applications'] });
    },
  });

  return (
    <Form
      form={form}
      layout="vertical"
      size={isMobile && 'large'}
      gap="middle"
      onFinish={requestChangesMutation.mutate}
    >
      <div>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.actions.requestChanges.subtitle'
        )}
      </div>

      <Form.Item
        label={getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.actions.requestChanges.changesRequired'
        )}
        name="changes_required"
        rules={[requiredField]}
      >
        <TextArea />
      </Form.Item>

      <Space>
        <Button
          type="primary"
          htmlType="submit"
          disabled={!values?.changes_required}
          loading={requestChangesMutation.isLoading}
        >
          {getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.review.actions.requestChanges.sendRequest'
          )}
        </Button>
      </Space>
    </Form>
  );
};

export default RequestChangesDrawer;
